module.exports = __webpack_public_path__ + "img/Slice7.0196be20.png";